import { supabase } from '@/lib/supabase';

export interface DeleteProjectMemberInviteInput {
  inviteId: number;
  projectId: string | undefined;
}

export const deleteProjectMemberInvite = async ({
  inviteId,
}: DeleteProjectMemberInviteInput) => {
  const { error } = await supabase
    .from('project_member_invites')
    .delete()
    .eq('id', inviteId)
    .eq('status', 'pending');

  if (error) {
    throw error;
  }
};
